import angular from 'angular';

angular.module('app.core').factory('StockSoftware', StockSoftware);

export default class StockSoftware {

    constructor(stockSoftware, $translate) {
        this.translate = $translate;
        this.id = stockSoftware.id
        this.name = stockSoftware.name;
        this.deleted = stockSoftware.deleted;
        this.modeMail = stockSoftware.modeMail;
        this.modeWebService = stockSoftware.modeWebService;
        this.editorName = stockSoftware.editorName;
        this.phone = stockSoftware.phone;
        this.fax = stockSoftware.fax;
        this.webSite = stockSoftware.webSite;
        this.contactEmails = stockSoftware.contactEmails;
        this.presalesEmails = stockSoftware.presalesEmails;
        this.countryCode = stockSoftware.countryCode;
        this.techEmails = stockSoftware.techEmails;
        this.alertEmails = stockSoftware.alertEmails;
        this.buildAddress(this, stockSoftware);
    }

     getCountryLabel() {
             if (this.countryCode) {
                 return this.translate.instant('country.' + angular.lowercase(this.countryCode));
             }
             return '';
         }


    buildAddress(current, stockSoftware) {
        current.address1 = stockSoftware.address1 || null;
        current.address2 = stockSoftware.address2 || null;
        current.zipCode = stockSoftware.zipCode || null;
        current.city = stockSoftware.city || null;
    }
}
